$ ->
  return if $('[data-video-ctrl]').length < 1

  bindVideos = (idx, ctrl) ->
    video = document.getElementById $(ctrl).data('video-ctrl')
    return if video.length < 1

    video.addEventListener 'play', ( =>
      $(ctrl).find(".js-play").hide()
      $(ctrl).find(".js-pause").show()
    ), false

    video.addEventListener 'pause', ( =>
      $(ctrl).find(".js-play").show()
      $(ctrl).find(".js-pause").hide()
    ), false

    $(ctrl).on 'click', ( =>
      if video.paused
        video.play()
      else
        video.pause()
    )

  bindControls = () ->
    $('[data-video-ctrl]').each bindVideos
    return
  
  $(document).on 'ready', bindControls